<template>
  <div>
    <el-form
      v-if="!showSuccessMessage"
      ref="form"
      :model="form"
      :rules="rules"
      class="form__reset-password"
      @submit.native.prevent="onSubmit"
    >
      <el-form-item :label="$t('Email')" prop="email">
        <el-input v-model="form.email" clearable type="email" placeholder="me@example.com"></el-input>
      </el-form-item>

      <el-form-item class="m-t-2 m-b-0">
        <el-button type="primary" native-type="submit" class="w-100" :loading="loading">{{ $t('Reset password') }}</el-button>
      </el-form-item>
    </el-form>

    <div v-if="showSuccessMessage">
      <el-alert
        :title="$t('Request for password reset')"
        :closable="false"
        type="success"
        :description="$t('You have successfully reseted your password. Please check your e-Mail account for further instructions')"
        show-icon
      ></el-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormResetPassword',

  data() {
    return {
      showSuccessMessage: false,
      form: {
        email: ''
      },
      loading: false,
      rules: {
        email: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('Please enter valid email address'),
            trigger: 'blur'
          }
        ]
      }
    };
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.resetPassword();
        } else {
          return false;
        }
      });
    },

    resetPassword() {
      console.log('resetPassword');
      this.loading = true;

      this.$store
        .dispatch('auth/RESET_PASSWORD', this.form.email)
        .then(result => {
          this.loading = false;

          console.log('resetPassword', result);

          // Incorrect authentification
          if (result.code && result.message) {
            this.$message({
              message: result.message,
              type: 'error',
              showClose: true,
              duration: 10000
            });

            return false;
          }

          // Show success message
          if (result.public) {
            this.showSuccessMessage = true;
          }
        })
        .catch(err => {
          this.loading = false;

          console.log('auth error', err);
        });
    }
  }
};
</script>
